import React, { useState } from "react";
import CustomTable from "../components/Table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const Categories = () => {
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");

  const data = [
    { id: 1, name: "Technology", sub: "Hardware Cost" },
    { id: 2, name: "Taxes", sub: "Payroll Taxes" },
    { id: 3, name: "Recruitment", sub: "Advertisement" },
    { id: 4, name: "Compensation", sub: "Incentive" },
  ];

  const filtered = data.filter(d =>
    d.name.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" /> },
    { title: "Category Name", dataIndex: "name" },
    { title: "Sub Category", dataIndex: "sub" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Categories"
      columns={columns}
      data={filtered}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearch}
    />
  );
};

export default Categories;